// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2CdEe","title":"Header_title__10Ei_","side":"Header_side__UEaKY"};